import React from 'react';
import { FemEntityLanding } from './pages/FemEntityLanding';
import { InvestorsPage } from './pages/InvestorsPage';
import { PractitionersPage } from './pages/PractitionersPage';
export function App() {
  const path = window.location.pathname;
  if (path === '/investors') {
    return <InvestorsPage data-id="element-0" />;
  }
  if (path === '/practitioners') {
    return <PractitionersPage data-id="element-1" />;
  }
  return <FemEntityLanding data-id="element-2" />;
}